import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import { getAdultsChildrenInfantsCount, hasChildren } from '@/utils/peopleUtils.ts';

// MPH-787: 1 pax is out of both price-display tests, families only get cux_4030, everyone else only cux_4027.
export type PriceDisplaySegment = 'single' | 'family' | 'multiPax';

export const getPriceDisplaySegment = (searchParams: SearchParams): PriceDisplaySegment => {
  if (getAdultsChildrenInfantsCount(searchParams) === 1) return 'single';

  return hasChildren(searchParams[URLParameters.AGES]) ? 'family' : 'multiPax';
};
